import { Http, Headers, RequestOptions } from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import * as myGlobals from '../global';

@Injectable()
export class SiteConfigurationService {

  public Site = {
    Logo: "",
    SiteName: "",
    Url: "",
    UrlLabel: "",
    Contacts: "",
    HomeSlideShow: "",          //List<ImageSequenceItem>
    HomeDescription: "",        //Dictionary<string, string>
    NotifyToBc: "",             //NotifyToBc 
    Footer: "",                 //Dictionary<string, string>
    Menus: "",                  //SiteMenu[] 
    Theme: "",                  //Theme 
    Print: "",                  //Print2 
    Languages: "",              //string[] 
    AutoLanguagesTranslator: "" //bool 
  }

  public E400 = {
    apiAllowedDomain: [],
      agencyFeature:{
          type: ""
      },
      privacy: { 
        owner: "", 
        ownerEmail: "", 
        fullCompany: "", 
        pdfFile: ""
      },

      backOffice: {
        print: {
          logo: "",
          company: ""
        }
      },
    
      network:  {
        coverImage: "", 
        logo: "",
        title: "",
        summary: {
          it: ""
        }
      },

      images: {
        maxFileSize: 50000000,
        noAdsImagePlaceHolder: "",
        watermark: {
          image: "", 
          trasparency: 50,
          mode: 1,
          position: 1
        }
      },
      
      externals: {
        google: {
          recaptcha:  {publicKey: "", privateKey: ""},
          maps:       {apiKey: ""},
          analitics:  {codeId: ""}
        },
        
        facebook: {
          appId: "",
          pageUrl: ""
        },

        immobiliareIT: ""
      },
    
      site: this.Site,
      
      geo: {
        geometry:[], 
        address:{
          aa1: "",
          aa2: "",
          aa3: "",
          aa4: "",
          aa5: "",
          country: "",
          locality: "",
          route: ""
        },
        label: "",
        zoomLevel: 16
      },
    
      creationDate: ""
  }

  public MyConfiguration = [];

  // public MyConfiguration = {
  //   apiKey: "",
  //   businessID: "",
  //   e100:{},
  //   e200:{},
  //   e300:{},
  //   e400: this.E400 
  // };

  public HomeContents = {
      HomeDescription: ""
  };

  private isFillerUpdated: any = false;

  private config: Object = null;
  private env:    Object = null;

  constructor(private http: Http) { 
    this.load();
  }

  public getConfig(key: any) {
      return this.MyConfiguration[key];
  }

  public getFullConfig() {
      return this.MyConfiguration;
  }

  public load() {

    return new Promise((resolve, reject) => {

      var payload = {};
      var url = myGlobals.apiBasePath + "/Public/ServiceRealEstate/configuration";

      var response;
      var headers = new Headers({ 'Content-Type': 'application/json' });
      headers.append('api_key', myGlobals.apikey);

      var data2 = payload == "" ? JSON.stringify({ "UICulture": "it"}) : JSON.stringify(payload) ;   
      var options = new  RequestOptions({ headers: headers });

      response = this.http.post(url,data2,options)
          .map( res => res.json() )
          .catch((error: any):any => {
    
            resolve(true);
            return Observable.throw(error.json().error || 'Server error');
      
          }).subscribe( (envResponse) => {
                
                this.env = envResponse;
                let request:any = null;
                
                this.MyConfiguration = Object.assign([], envResponse)

                resolve(true);
               
                /*switch (envResponse.env) {
                    case 'production': {
                        request = this.http.get('config.' + envResponse.env + '.json');
                    } break;

                    case 'development': {
                        request = this.http.get('config.' + envResponse.env + '.json');
                    } break;

                    case 'default': {
                        console.error('Environment file is not set or invalid');
                        resolve(true);
                    } break;
                }*/
              
            });

    });

  }

}



// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/common/site-configuration.service.ts